import diamond from 'images/sponsorships/partner.jpg';
// import gold from 'images/sponsorships/netgala.jpg';
import profile from 'images/sponsorships/profilephoto.jpg';
import recharge from 'images/sponsorships/recharge.jpg';
import businessHub from 'images/sponsorships/businesshub.jpg';
import gaming from 'images/sponsorships/gaming.jpg';
import photoBooth from 'images/sponsorships/photobooth.jpg';
import wifi from 'images/sponsorships/wifi.jpg';
import coffee from 'images/sponsorships/coffee.jpg';
import water from 'images/sponsorships/water.jpg';
import massage from 'images/sponsorships/massage.jpg';
import beerGarden from 'images/sponsorships/beergarden.jpg';
import speech from 'images/sponsorships/speaking.jpg';
import stage from 'images/sponsorships/stage.jpg';
import bar from 'images/sponsorships/bar.jpg';
import hotel from 'images/sponsorships/hotel.jpg';

// sponsor slider
import awpartner1 from 'images/sponsorships/slider/awpartner-1.jpg';
import awpartner2 from 'images/sponsorships/slider/awpartner-2.jpg';
import awpartner3 from 'images/sponsorships/slider/awpartner-3.jpg';
import awpartner4 from 'images/sponsorships/slider/awpartner-4.jpg';
import awpartner6 from 'images/sponsorships/slider/awpartner-6.jpg';
import awpartner7 from 'images/sponsorships/slider/awpartner-7.jpg';
import beergarden1 from 'images/sponsorships/slider/beergarden-1.jpg';
import beergarden3 from 'images/sponsorships/slider/beergarden-3.jpg';
import beergarden4 from 'images/sponsorships/slider/beergarden-4.jpg';
import beergarden5 from 'images/sponsorships/slider/beergarden-5.jpg';
import businesshub1 from 'images/sponsorships/slider/businesshub-1.jpg';
import businesshub2 from 'images/sponsorships/slider/businesshub-2.jpg';
import businesshub3 from 'images/sponsorships/slider/businesshub-3.jpg';
import businesshub4 from 'images/sponsorships/slider/businesshub-4.jpg';
import coffee1 from 'images/sponsorships/slider/coffee-1.jpg';
import coffee2 from 'images/sponsorships/slider/coffee-2.jpg';
import coffee3 from 'images/sponsorships/slider/coffee-3.jpg';
import coffee4 from 'images/sponsorships/slider/coffee-4.jpg';
import gaming1 from 'images/sponsorships/slider/gaming-1.jpg';
import gaming2 from 'images/sponsorships/slider/gaming-2.jpg';
import gaming3 from 'images/sponsorships/slider/gaming-3.jpg';
import gaming4 from 'images/sponsorships/slider/gaming-4.jpg';
import massage1 from 'images/sponsorships/slider/massage-1.jpg';
import massage2 from 'images/sponsorships/slider/massage-2.jpg';
import massage3 from 'images/sponsorships/slider/massage-3.jpg';
import massage4 from 'images/sponsorships/slider/massage-4.jpg';
// import netgala1 from 'images/sponsorships/slider/netgala-1.jpg';
// import netgala2 from 'images/sponsorships/slider/netgala-2.jpg';
// import netgala3 from 'images/sponsorships/slider/netgala-3.jpg';
// import netgala4 from 'images/sponsorships/slider/netgala-4.jpg';
import photobooth1 from 'images/sponsorships/slider/photobooth-1.jpg';
import photobooth2 from 'images/sponsorships/slider/photobooth-2.jpg';
import photobooth3 from 'images/sponsorships/slider/photobooth-3.jpg';
import photobooth4 from 'images/sponsorships/slider/photobooth-4.jpg';
import photobooth5 from 'images/sponsorships/slider/photobooth-5.jpg';
import photobooth6 from 'images/sponsorships/slider/photobooth-6.jpg';
import profilephoto1 from 'images/sponsorships/slider/profilephoto-1.jpg';
import profilephoto2 from 'images/sponsorships/slider/profilephoto-2.jpg';
import profilephoto3 from 'images/sponsorships/slider/profilephoto-3.jpg';
import profilephoto4 from 'images/sponsorships/slider/profilephoto-4.jpg';
import profilephoto5 from 'images/sponsorships/slider/profilephoto-5.jpg';
import recharge1 from 'images/sponsorships/slider/recharge-1.jpg';
import recharge2 from 'images/sponsorships/slider/recharge-2.jpg';
import recharge3 from 'images/sponsorships/slider/recharge-3.jpg';
import recharge4 from 'images/sponsorships/slider/recharge-4.jpg';
import speaking1 from 'images/sponsorships/slider/speaking-1.jpg';
import speaking2 from 'images/sponsorships/slider/speaking-2.jpg';
import speaking3 from 'images/sponsorships/slider/speaking-3.jpg';
import speaking4 from 'images/sponsorships/slider/speaking-4.jpg';
import stage1 from 'images/sponsorships/slider/stage-1.jpg';
import stage2 from 'images/sponsorships/slider/stage-2.jpg';
import stage3 from 'images/sponsorships/slider/stage-3.jpg';
import stage4 from 'images/sponsorships/slider/stage-4.jpg';
import water1 from 'images/sponsorships/slider/water-1.jpg';
import water2 from 'images/sponsorships/slider/water-2.jpg';
import water3 from 'images/sponsorships/slider/water-3.jpg';
import wifi1 from 'images/sponsorships/slider/wifi-1.jpg';
import wifi2 from 'images/sponsorships/slider/wifi-2.jpg';
import wifi3 from 'images/sponsorships/slider/wifi-3.jpg';
import wifi4 from 'images/sponsorships/slider/wifi-4.jpg';
import bar1 from 'images/sponsorships/slider/bar-1.jpg';
import bar2 from 'images/sponsorships/slider/bar-2.jpg';
import bar3 from 'images/sponsorships/slider/bar-3.jpg';
import bar4 from 'images/sponsorships/slider/bar-4.jpg';
import bar5 from 'images/sponsorships/slider/bar-5.jpg';
import hotel1 from 'images/sponsorships/slider/hotel-1.jpg';
import hotel2 from 'images/sponsorships/slider/hotel-2.jpg';
import hotel3 from 'images/sponsorships/slider/hotel-3.jpg';
import hotel4 from 'images/sponsorships/slider/hotel-4.jpg';
import hotel5 from 'images/sponsorships/slider/hotel-5.jpg';

export const SPONSORSHIPS = {
  'sponsor-official-affiliate-world-partner': {
    name: 'Official Partner',
    thumbnail: diamond,
    name_full: 'Official Sellers World Partner',
    about: 'Soar to new heights of recognition with the highest possible level of exposure before, during, and after the event. Attendees will see your brand everywhere from digital branding on the SWC homepage to the signage at the conference entrance and throughout the exhibition hall. This sponsorship literally pays for itself as it comes with a Premium booth, 10 Company passes, and five Affiliate passes (valued at $38,199).',
    slider: [awpartner6, awpartner1, awpartner2, awpartner3, awpartner4, awpartner7],
    savings: '14,801',
    inclusions: [
      'One of four Official Sellers World Partners',
      'Lanyard, badges, and staff t-shirt branding',
      'Branding throughout exhibition hall and entrances (excluding stage)',
      'Branding on home page of website',
      'Video interview at the event to be posted on Facebook',
      '10 Company passes (valued at $17,000) 5 Affiliate passes to give away',
      '50% off additional Company passes',
      'Full page feature on the market booklet',
      'Logo on website, app, email,',
      'Dedicated social media post',
      // 'Thanks and logo announced on stage',
      'Logo on wrap video posted on Facebook',
      'Logo watermarked on all conference photos (excluding exclusively sponsored sections)',
    ],
    inclusionBlurb: 'Ten Company Passes, Affiliate Passes, branding and more...',
  },
  'sponsor-recharge': {
    name: 'Recharge Zone',
    thumbnail: recharge,
    name_full: 'Recharge Zone Sponsor',
    about: 'The Recharge Zone is the hub for attendees to charge up their gadgets, watch speeches, chat with other attendees, all while being surrounded exclusively by your brand. Recharge Zone users will see your video ad on repeat during ad breaks, and to top if off, this sponsorship package includes a Classic booth and four Company passes (valued at $13,999).',
    slider: [recharge1, recharge2, recharge3, recharge4],
    savings: '12,801',
    inclusions: [
      'Exclusive Recharge sponsor',
      'Branding on recharge lounge area and on gadget recharge stations',
      'Rechare area has live feed of stage content',
      'Video ad on cycle during ad breaks',
      'Recharge area has live feed of stage content',
      'Four Company passes (valued at $6,800)',
      '30% off on additional Company passes',
      'Half-page feature on the market booklet',
      'Logo on website, app, and email',
      'Dedicated social media post',
      'Logo on wrap video posted on Facebook',
    ],
    inclusionBlurb: 'Four Company Passes, branding and more...',
  },
  'sponsor-profile-photo': {
    name: 'Profile Photo',
    thumbnail: profile,
    name_full: 'Profile Photo Sponsor',
    about: 'Who could say no to a free, professionally captured profile picture? Attendees will love you for providing them with their new professional headshots. As a bonus, our exclusive Profile Photo Sponsor will receive one of the few Premium booths on prime real estate and four Company passes (valued at $21,999).',
    slider: [profilephoto1, profilephoto2, profilephoto3, profilephoto4, profilephoto5],
    savings: '4,801',
    inclusions: [
      'Exclusive Profile Photo sponsor',
      'Logo on profile photo booth',
      'Free professional profile photos for all attendees',
      'Prime exhibition floor location',
      'Four Company passes (valued at $6,800)',
      '30% off on additional Company passes',
      'Half-page feature on the market booklet',
      'Logo on website, app, and email',
      'Dedicated social media post',
      // 'Thanks and logo announced on stage',
      'Logo on wrap video posted on Facebook',
    ],
    inclusionBlurb: 'Four Company Passes, branding and more...',
  },
  'sponsor-business-hub': {
    name: 'Business Hub',
    thumbnail: businessHub,
    name_full: 'Business Hub Sponsor',
    about: 'Host meetings and networkings surrounded exclusively by your branding in the Business Hub situated in a prime location on the exhibition floor. Plus this sponsorship includes a Premium booth and four Company passes (valued at $21,999)',
    slider: [businesshub1, businesshub2, businesshub3, businesshub4],
    savings: '4,801',
    inclusions: [
      'Exclusive Business Hub sponsor',
      'Branding of the Business Hub area',
      'Exposure to attendees hosting meetings and networking in the area',
      'Prime exhibition floor location',
      'Four Company passes (valued at $6,800)',
      '30% off on additional Company passes',
      'Half-page feature on the market booklet',
      'Logo on website, app, and email',
      'Dedicated social media post',
      // 'Thanks and logo announced on stage',
      'Logo on wrap video posted on Facebook',
    ],
    inclusionBlurb: 'Four Company Passes, branding and more...',
  },
  // 'sponsor-networking-drinks': {
  //   name: 'Networking Drinks at Beachfront Club',
  //   thumbnail: gold,
  //   name_full: 'Networking Drinks at Beachfront Club Sponsor',
  //   about: 'Host AWA’s most popular event, the Networking Drinks at Beachfront Club. Be at the heart of attendees rubbing shoulders and forging friendships with the top marketing minds in the industry over drinks at a beachfront club. Plus indulge in a branded VIP table with complimentary premium drinks package. Be one of six Networking Sponsors and see your branding spread throughout the venue, from promotional materials to your logo watermarked on hundreds of photos commemorating the night. On top of that, you’ll get 150 complimentary drinks for you to give away to attendees – a perk everyone enjoys.',
  //   slider: [netgala1, netgala2, netgala3, netgala4],
  //   savings: '6,800',
  //   inclusions: [
  //     'One of six Networking Drink sponsors at beachfront club',
  //     'Branded VIP table with complimentary premium drinks package',
  //     '150 free drink tokens to give away',
  //     'Your logo on display during event',
  //     'Four Company passes (valued at $6,800)',
  //     '30% off additional Company passes',
  //     'Full page feature in the market booklet',
  //     'Logo on website, app, email, and flyers',
  //     'Dedicated social media post',
  //     'Thanks and logo announced on stage',
  //     'Logo on wrap video posted on social media',
  //     'Logo watermarked on all photos of Networking Drinks at Beachfront Club, posted on social media',
  //   ],
  //   inclusionBlurb: 'Four Company Passes, branding and more...',
  // },
  'sponsor-gaming-booth': {
    name: 'Gaming Booth',
    thumbnail: gaming,
    name_full: 'Gaming Booth Sponsor',
    about: 'A popular attraction for attendees, your booth will come equipped with an arcade game that&apos;ll surely catch attention. It’s the place where affiliates come to mix business with pleasure in a prime location on the exhibition floor. This package includes a Classic booth and four Company passes (valued at $13,999).',
    slider: [gaming1, gaming2, gaming3, gaming4],
    savings: '7,801',
    inclusions: [
      'Exclusive Gaming Booth sponsor',
      'Arcade game included in booth design',
      'Popular area attracting attendees',
      'Prime exhibition floor location',
      'Four Company passes (valued at $6,800)',
      '30% off on additional Company passes',
      'Half-page feature on the market booklet',
      'Logo on website, app, and email',
      'Dedicated social media post',
      // 'Thanks and logo announced on stage',
      'Logo on wrap video posted on Facebook',
    ],
    inclusionBlurb: 'Four Company Passes, branding and more...',
  },
  'sponsor-photo-booth': {
    name: 'Photo Booth',
    thumbnail: photoBooth,
    name_full: 'Photo Booth Sponsor',
    about: 'Make the Photo Booth yours with your branding featuring in attendees&apos; fun photos that will be shared like wildfire on social media. The Photo Booth is located among the exhibition floor and also includes a Classic booth and four Company passes (valued at $13,999).',
    slider: [photobooth1, photobooth2, photobooth3, photobooth4, photobooth5, photobooth6],
    savings: '7,801',
    inclusions: [
      'Exclusive Photo Booth sponsor',
      'Branding on the Photo Booth',
      'Popular area attracting attendees',
      'Prime exhibition floor location',
      'Four Company passes (valued at $6,800)',
      '30% off on additional Company passes',
      'Half-page feature on the market booklet',
      'Logo on website, app, and email',
      'Dedicated social media post',
      // 'Thanks and logo announced on stage',
      'Logo on wrap video posted on Facebook',
    ],
    inclusionBlurb: 'Four Company Passes, branding and more...',
  },
  'sponsor-wifi': {
    name: 'Wifi',
    thumbnail: wifi,
    name_full: 'Wifi Sponsor',
    about: 'Wifi, as we all know, is essential. Attendees will receive wifi login cards and see “AW Wifi by YOUR COMPANY NAME” when they connect, and your brand name will be the password. This package includes a free Classic booth and four Company passes (valued at $13,999).',
    slider: [wifi1, wifi2, wifi3, wifi4],
    savings: '7,801',
    inclusions: [
      'Exclusive Wifi sponsor',
      'Company name included in official SWC wifi name',
      'Custom password of your choice',
      'Prime exhibition floor location',
      'Four Company passes (valued at $6,800)',
      '30% off on additional Company passes',
      'Half-page feature on the market booklet',
      'Logo on website, app, and email',
      'Dedicated social media post',
      // 'Thanks and logo announced on stage',
      'Logo on wrap video posted on Facebook',
    ],
    inclusionBlurb: 'Four Company Passes, branding and more...',
  },
  'sponsor-hotel': {
    name: 'Official Hotel',
    thumbnail: hotel,
    name_full: 'Official Hotel Sponsor',
    about: 'Be the brand that greets attendees staying at the official SWC hotel. Have your logo displayed on attendee hotel key card sleeves, your banners on display, and get exclusive use of a private meeting room in the hotel so you can set appointments and do business with your clients throughout AWA. With this sponsorship package, you’ll be recognised by attendees even before they step foot in the actual conference! This package includes a Classic booth and four Company passes (valued at $15,000)',
    slider: [hotel1, hotel2, hotel3, hotel4, hotel5],
    savings: '7,801',
    inclusions: [
      'Exclusive official hotel sponsor',
      'Logo on all attendee key card sleeves ',
      'Four pull-up banners at the top of the escalator leading from the hotel lobby to the conference centre',
      'Exclusive use of a meeting room in the official hotel',
      'Prime exhibition floor location',
      'Four Company passes (valued at $6,800)',
      '30% off on additional Company passes',
      'Half-page feature on the market booklet',
      'Logo on website, app, and email',
      'Dedicated social media post',
      'Logo on wrap video posted on Facebook',
    ],
    inclusionBlurb: 'Four Company Passes, branding and more...',
  },
  'sponsor-coffee': {
    name: 'Coffee',
    thumbnail: coffee,
    name_full: 'Coffee Sponsor',
    about: 'As one of two coffee sponsors, attendees needing an extra jolt of energy will have your brand to thank. Free tea and coffee will be served from a prime location. The cherry on top? A free Classic booth and four Company passes (valued at $13,999).',
    slider: [coffee1, coffee2, coffee3, coffee4],
    savings: '7,801',
    inclusions: [
      'One of two Official Coffee sponsors',
      'Your logo on two coffee stations in the exhibition hall',
      'Free tea and filter coffee served in your branded cups',
      'Prime exhibition floor location',
      'Four Company passes (valued at $6,800)',
      '30% off on additional Company passes',
      'Half-page feature on the market booklet',
      'Logo on website, app, and email',
      'Dedicated social media post',
      // 'Thanks and logo announced on stage',
      'Logo on wrap video posted on Facebook',
    ],
    inclusionBlurb: 'Four Company Passes, branding and more...',
  },
  'sponsor-water': {
    name: 'Water',
    thumbnail: water,
    name_full: 'Water Sponsor',
    about: 'Keep attendees hydrated and in the know about your brand by sponsoring eight water stations, with your branding on water dispensers and drinking cups throughout the event. Includes a free Classic booth and four company passes (valued at $13,999)',
    slider: [water1, water2, water3],
    savings: '7,801',
    inclusions: [
      'Exclusive Water sponsor',
      'Eight stations offering free water',
      'Branding on water dispensers and drinking cups',
      'Prime exhibition floor location',
      'Four Company passes (valued at $6,800)',
      '30% off on additional Company passes',
      'Half-page feature on the market booklet',
      'Logo on website, app, and email',
      'Dedicated social media post',
      // 'Thanks and logo announced on stage',
      'Logo on wrap video posted on Facebook',
    ],
    inclusionBlurb: 'Four Company Passes, branding and more...',
  },
  'sponsor-massage': {
    name: 'Massage',
    thumbnail: massage,
    name_full: 'Massage Sponsor',
    about: 'Who says no to a free massage? Two busy massage stations branded with your company name will be placed at key locations in the venue. Plus there’s a free Classic booth and four Company passes (valued at $13,999).',
    slider: [massage1, massage2, massage3, massage4],
    savings: '7,801',
    inclusions: [
      'Exclusive Massage sponsor',
      'Two stations with 3 massueses each offering 10-minute massages',
      'Masseuses wearing your branded t-shirt',
      'A pull-up banner with your logo at each station',
      'Four Company passes (valued at $6,800)',
      '30% off on additional Company passes',
      'Half-page feature on the market booklet',
      'Logo on website, app, and email',
      'Dedicated social media post',
      // 'Thanks and logo announced on stage',
      'Logo on wrap video posted on Facebook',
    ],
    inclusionBlurb: 'Four Company Passes, branding and more...',
  },
  'sponsor-beer-garden': {
    name: 'Beer Garden',
    thumbnail: beerGarden,
    name_full: 'Beer Garden Sponsor',
    about: 'Ice cold beer under the hot Barcelona sun? Be one of two hosts of the official Beer Garden, the only outdoor space in the conference. Treat attendees to 2-for-1 drinks during happy hour on both days, takeover the cups with your brand and give attendees the perfect hangout spot with your name on it. Plus you’ll get 4 free Company passes for your team.',
    slider: [beergarden5, beergarden1, beergarden3, beergarden4],
    savings: '6,800',
    inclusions: [
      'One of two official Beer Garden sponsors',
      'Branding in the only outdoor location in the conference',
      'Branded beer cups, and shirts worn by service staff',
      '2-for-1 Happy Hour on both days',
      'Four Company passes (valued at $6,800)',
      '30% off on additional Company passes',
      'Half-page feature on the market booklet',
      'Logo on website, app, and email',
      'Dedicated social media post',
      'Thanks and logo announced on stage',
      'Logo on wrap video posted on Facebook',
    ],
    inclusionBlurb: 'Four Company Passes, branding and more...',
  },
  'sponsor-stage-branding': {
    name: 'Stage Branding',
    thumbnail: stage,
    name_full: 'Stage Branding',
    about: 'Want your company name on the most visited area of the conference? Have your logo featured between speeches on stage and gain extra exposure to thousands of attendees. This package includes a Classic booth and two Company passes (valued at $10,599).',
    slider: [stage1, stage2, stage3, stage4],
    savings: '7,801',
    inclusions: [
      'One of four Stage Branding sponsors',
      'Logo featured between speeches on stage',
      'Exposure to thousands of attendees watching speeches',
      'Branding in most visited area in the conference',
      'Two Company passes (valued at $3,400)',
      '30% off on additional Company passes',
      'Half-page feature on the market booklet',
      'Logo on website, app, and email',
      'Dedicated social media post',
      'Thanks and logo announced on stage',
      'Logo on wrap video posted on social media',
    ],
    inclusionBlurb: 'Two Company Passes, branding and more...',
  },
  'sponsor-official-bar': {
    name: 'Official Bar',
    thumbnail: bar,
    name_full: 'Official Bar',
    about: 'Be one of two Official Bar sponsors and get your branding on the exhibition bar during the entire conference. Takeover the cups with your brand and give attendees the perfect hangout spot with your name on it. Plus you’ll get four Company passes for your team (valued at $6,800).',
    slider: [bar1, bar2, bar3, bar4, bar5],
    savings: '5,301',
    inclusions: [
      'One of two Exhibition Bar sponsors',
      'Branding at the exhibition bar during the entire conference',
      '500 Branded beer cups',
      'Video ad on cycle on TVs in the bar',
      'Four Company passes (valued at $6,800)',
      '30% off on additional Company passes',
      'Half-page feature on the market booklet',
      'Logo on website, app, and email',
      'Dedicated social media post',
      'Logo on wrap video posted on Facebook',
    ],
    inclusionBlurb: 'Four Company Passes, branding and more...',
  },
  'sponsor-speech': {
    name: 'Speaking Opportunities',
    thumbnail: speech,
    name_full: 'Speaking Opportunities',
    about: 'Step into the limelight. For twenty minutes, all eyes are on your brand. Present a speech or panel discussion in front of the world’s most influential performance marketers and ecommerce entrepreneurs on Asia’s main stage. The perfect add-on package for companies wanting to go the extra mile with increased exposure to attendees.',
    slider: [speaking1, speaking2, speaking3, speaking4],
    savings: '6,800',
    inquiry: true,
    hideCount: true,
    inclusions: [
      'Official Speaker at Sellers World',
      'One 20-min speech or panel on stage',
      'Video of presentation recorded',
      'Video released online after the event',
      'Company passes (valued at $1,700 each)',
      '30% off on additional Company passes',
      'Half-page feature on the market booklet',
      'Logo on website, app, and email',
      'Dedicated social media post',
      // 'Thanks and logo announced on stage',
      'Logo on wrap video posted on Facebook',
    ],
    inclusionBlurb: 'Company Passes, branding and more...',
  },
};



// WEBPACK FOOTER //
// ./src/common/sponsorships.js